import React from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import type { ColProps } from 'react-bootstrap'
import { ShowIf } from '../ShowIf'

export type LabelValueBlockProps = {
  label?: React.ReactNode
  value: React.ReactNode
  className?: string
  borderBottom?: string
  labelWidth?: ColProps['md'] //whatever the bootstrap colProps is, we use it
}
export const LabelValueBlock = ({
  label,
  value,
  className = 'py-2',
  borderBottom = 'border-bottom',
  labelWidth = 5,
}: LabelValueBlockProps) => {
  const secondColWidth = typeof labelWidth === 'number' ? 12 - labelWidth : undefined

  return (
    <Row className={`${className} ${borderBottom} `}>
      <ShowIf condition={!!label}>
        <Col md={labelWidth}>
          <Form.Label className={` text-capitalize small fw-bold`}>{label}</Form.Label>
        </Col>
      </ShowIf>
      <Col md={secondColWidth} className="fw-bold d-flex justify-content-end">
        {value}
      </Col>
    </Row>
  )
}
